import { DataGrid } from "devextreme-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDataSource } from "../../../../contexts/dataSource";
import { useAuth } from "../../../../contexts/auth";
import { getPropsDataGrid, getPropsDataGridColSpan, getPropsDataGridEditing, getPropsDataGridPopup, getPropsDateEdit, getPropsLookupExprForIdName, getPropsLookupExprForIdText } from "../../../../utils/default-props";
import { Column, Editing, FormItem, Lookup, Popup } from "devextreme-react/data-grid";
import { definitions, useDefinitionList } from "../../../../contexts/definitions-list-context";

function Certificate({ employeeId }) {

    const { dataSourceHR } = useDataSource()
    const { user } = useAuth()
    const {getDefinitionList} = useDefinitionList()

    const [certificateCategory, setCertificateCategory] = useState()

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeCertificate/Employee/${employeeId}`,
        insertUrl: "/api/EmployeeCertificate/FormData"
    }), [user, employeeId])

    const handleInitNewRow = useCallback((e) => {
        e.data.employeeId = employeeId
    }, [employeeId])

    const dbcertificateCategory = useMemo(()=> dataSourceHR({
        loadUrl: "/api/CertificateCategoryInfo"
    }),[])

    useEffect(()=>{
        getDefinitionList(definitions.certificateCategoryInfo, true).then(response => setCertificateCategory(response))
    },[])

    return (
        <React.Fragment>
            <DataGrid
                dataSource={employeeId ? dataSource : undefined}
                {...getPropsDataGrid}
                onInitNewRow={handleInitNewRow}
            >
                <Editing {...getPropsDataGridEditing}>
                    <Popup {...getPropsDataGridPopup} />
                </Editing>
                <Column dataField="name" caption="Sertifika Adı" >
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
                <Column dataField="date" caption="Sertifika Tarihi" {...getPropsDateEdit}>
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
                <Column dataField="issuingInstitution" caption="Sertifika Veren Kurum">
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>

                <Column dataField="certificateCategoryInfoId" caption="Sertifika Kategorisi">
                    <Lookup dataSource={certificateCategory} {...getPropsLookupExprForIdText} />
                    <FormItem {...getPropsDataGridColSpan} />
                </Column>
            </DataGrid>
        </React.Fragment>
    )
}

export default Certificate